/**
 * The integer field type
 *
 * @group ISOBMFF
 *
 * @beta
 */
export const INT = 'int';
//# sourceMappingURL=INT.js.map